// extracted by mini-css-extract-plugin
export var brand = "_73-9";
export var compact = "_73-6";
export var extraSmall = "_73-7";
export var icon = "_73-0";
export var large = "_73-4";
export var light = "_73-1";
export var medium = "_73-5";
export var outline = "_73-b";
export var primaryDark = "_73-a";
export var primaryLight = "_73-8";
export var primaryModern = "_73-c";
export var success = "_73-2";
export var successSolid = "_73-3";